import { Ref } from 'vue';
import { inputField } from '@/ui/components/form';
import { Task, useValidation } from '@/ui/concerns';
import { Group, validate } from '@/entities/group';
import { apiErrorMessage } from '@/ui/components';
import { t } from '@/ui/i18n/i18n';
import { SelectOptions } from '@/ui/types';
import { chooseUserField } from '@/ui/components/user/ChooseUserField';
import { hasPermission, Permissions } from '@/ui/auth/auth';
import { CreateUserModelIdentifier } from '@/ui/components/user/CreateUserModal';

export function useGroupForm(record: Ref<Group>, task: Task) {
  const {
    validationErrors,
    hasNoValidationErrors,
    showValidationErrors,
  } = useValidation(validate, record, task.state);

  const handleSubmit = () => {
    showValidationErrors.value = true;
    if (hasNoValidationErrors.value) {
      task.run();
    }
  };

  const formFields = (userOptions: SelectOptions) => [
    inputField({
      name: 'title',
      label: t('group.title'),
      placeholder: t('group.enter-title'),
      value: record.value.title,
      required: true,
      errors: validationErrors.value,
      disabled: task.state.value.pending,
    },

    (value: string) => {
      record.value.title = value;
    }),

    hasPermission(Permissions.MANAGE_USERS) && chooseUserField({
      props: {
        value: record.value.users,
        options: userOptions,
        errors: validationErrors.value,
        disabled: task.state.value.pending,
        required: false,
        identifier: CreateUserModelIdentifier.groupCreator,
      },
      on: {
        input: (value: number[]) => {
          record.value.users = value;
        },
      },
    }),

    apiErrorMessage(task.state.value),
  ];

  return {
    formFields,
    handleSubmit,
  };
}
